<template>
    <div id="SliderComponent">
        <!-- {{ itensGroup }} -->
        <carousel-3d
        :autoplay="true"
        :minSwipeDistance="40"
        :startIndex="0"
        :height="height"
        :display="displayCount"
        :disable3d="true"
        :controlsVisible="false"
        :clickable="true"
        :dir="'ltr'"
        > 
            <slide v-for="(item, index) in itensGroup" :key="index" :index="index">
                <h4>{{item.title}}</h4>
                <img v-if="item.mainImage" :src="CDN_URL+item.mainImage" alt="" class="image-slider">
                <img v-else src="@/assets/img/default-image.png" alt="" class="image-slider">
            </slide>
        </carousel-3d>
    </div>
</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d';
import ImageBlock from '@/components/blocks/ImageBlock.vue';
export default {
    name:'SliderComponent',
    data(){
        return{
            CDN_URL: null
        }
    },
    props:{
        itensGroup:{
            type: Array,
            required: true
        },
        displayCount:{
            type: Number,
            required: false,
            default: 1
        },
        height:{
            type: Number,
            required: false,
            default: 400
        }
    },
    components: {
        Carousel3d,
        Slide,
        ImageBlock
    },
    created(){
        this.CDN_URL = process.env.CDN_URL
    }
}
</script>

<style scoped>
    .image-slider {
        max-width: 100%;
        padding: 10px 0;
        height: 600px;
        object-fit: cover;
    }
</style>



// WEBPACK FOOTER //
// src/components/blocks/SliderComponent.vue